import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import ConfirmDialog from "src/components/dialog/ConfirmDialog";
import { resendVerificationEmail, cancelUserDeletion } from "src/redux/actions/User";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Typography from "@mui/material/Typography";
import { api } from "src/api/endpoints";
import ChangeUserPlanDialog from "./components/ChangeUserPlanDialog";
import { useSelector } from "react-redux";
import ChangeRoleDialog from "./components/ChangeRoleDialog";
import ScheduleDeletionDialog from "./components/ScheduleDeletionDialog";

export const CustomerDataManagement = ({ user, role }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [isResendModalOpen, setIsResendModalOpen] = useState(false)
  const [isUserPlanChangeDialogOpen, setIsUserPlanChangeDialogOpen] = useState(false)
  const [isUserRoleChangeDialogOpen, setIsUserRoleChangeDialogOpen] = useState(false)
  const [isScheduleDeletionDialogOpen, setIsScheduleDeletionDialogOpen] = useState(false)

  const { user: myUser, userPlanChangeError, userPlanChangeSuccess } = useSelector((state) => state.User);

  const handleResendVerificationMail = () => {
    setIsResendModalOpen(false)
    dispatch(resendVerificationEmail(user._id))
    toast.success(t("views.customerDataManagement.resendSuccess"));
  }

  const handleCancelScheduledDeletion = async () => {
    try {
      await dispatch(cancelUserDeletion(user._id));
      toast.success(t("views.customerDataManagement.cancelDeletionSuccess"));
    } catch (error) {
      toast.error(t("views.customerDataManagement.cancelDeletionError"));
    }
  }

  useEffect(() => {
    if(userPlanChangeError){
      switch (userPlanChangeError) {
        case 'cantFindUserOrPlan':
          toast.error(t("views.customerDataManagement.cantFindResourcePlanChangeErr"))
          break
        case 'cantEditYourUser':
          toast.error(t("views.customerDataManagement.cantEditYourUserPlanChangeErr"))
          break
        case 'serverErr': 
          toast.error(t("views.customerDataManagement.serverErrChangePlanErr"))
          break
      }

    }
  }, [userPlanChangeError])

  useEffect(() => {
    if(userPlanChangeSuccess) {
      toast.success(t("views.customerDataManagement.changePlanSuccess"))
    }
  }, [userPlanChangeSuccess])

  const loginToUsersAccount = async () => {
    try {
      const {data, status} = await api.post('/user/sendOTP', {userId: user._id})

      if(status == 200){
        const queryParamsOb = {
          userId: user._id,
          otp: data.otp
        }

        const searchParams = new URLSearchParams(queryParamsOb)

        window.location.replace(`/adlogin?${searchParams.toString()}`)
      }
    } catch (error) {
      toast.error("User account login error")
    }
  }

  return (
    <>
      <Card sx={{
        border: user.role == 'admin' ? '1px solid #006AFF' : ''
      }}>
        <CardHeader title={t("views.customerDataManagement.accountManagement")} />
        <CardContent sx={{ pt: 0 }}>
          <Box sx={{display: 'flex', gap: '10px', flexWrap: "wrap"}}>
            <Button
              color="error"
              variant={user.toDelete ? "contained" : "outlined"}
              onClick={user.toDelete ? handleCancelScheduledDeletion : () => setIsScheduleDeletionDialogOpen(true)}>
              {user.toDelete ? t("views.customerDataManagement.cancelDeleteAccount") : t("views.customerDataManagement.deleteAccount")}
            </Button>
            <Button color="secondary" variant="outlined" onClick={() => setIsResendModalOpen(true)}>
              {t("views.customerDataManagement.resendVerificationEmail")}
            </Button>
            {role == 'admin' && user.role !== 'admin' ? (
              <Button color="primary" variant="outlined" onClick={loginToUsersAccount}>
                Login to user's account
              </Button>
            ) : null}
            {/*  && user.role !== 'admin' && myUser._id !== user._id */}
            {role == 'admin' && myUser._id !== user._id ? (
              <Button color="success" variant="outlined" onClick={() => setIsUserPlanChangeDialogOpen(true)}>
                {t("views.customerDataManagement.planAssign")}
              </Button>
            ) : null}
            {role == 'admin' && myUser._id !== user._id ? (
              <Button variant="outlined" onClick={() => setIsUserRoleChangeDialogOpen(true)}>
                Set role
              </Button>
            ) : null}            
          </Box>
          <Box sx={{ mt: 1 }}>
            <Typography color="text.secondary" variant="body2">
              {t("views.customerDataManagement.deleteWarning")}
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <ConfirmDialog
        open={isResendModalOpen}
        title={t("views.customerDataManagement.confirmResend")}
        onClose={() => setIsResendModalOpen(false)}
        onAccept={handleResendVerificationMail}
      />

      <ChangeRoleDialog open={isUserRoleChangeDialogOpen} setOpen={setIsUserRoleChangeDialogOpen} currentUser={user} />

      <ChangeUserPlanDialog open={isUserPlanChangeDialogOpen} setOpen={setIsUserPlanChangeDialogOpen} currentPlanId={user?.plan?._id} userId={user?._id} />

      <ScheduleDeletionDialog open={isScheduleDeletionDialogOpen} setOpen={setIsScheduleDeletionDialogOpen} userId={user?._id} />
    </>
  );
};
